/**
 * Reordena el set de fotos destacadas del hero de RosterServicePage
 * (/impulsadoras-promotoras, /anfitrionas) para que la primera — la que se
 * renderiza `loading="eager"` + `fetchPriority="high"`, candidata real a
 * LCP — sea una que ya tenga miniatura optimizada (~640px webp), en vez de
 * la foto original (hasta 1600px) que getPromotorasGalleryPublic sirve como
 * fallback para fotos subidas antes de que existiera esa miniatura (ver
 * storage_path_thumb). No reordena el resto del set salvo mover esa foto al
 * frente — respeta el `orden` del admin para las miniaturas chicas — y no
 * cambia nada si ninguna foto del set tiene miniatura.
 */
export function orderForHeroCollage<T extends { hasThumb: boolean }>(featured: T[]): T[] {
  const bigIndex = featured.findIndex((p) => p.hasThumb);
  if (bigIndex <= 0) return featured;
  const big = featured[bigIndex];
  return [big, ...featured.slice(0, bigIndex), ...featured.slice(bigIndex + 1)];
}
